import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { getProcedure } from "../../api/procedure";
import { getProcedureRole } from "../../api/procedure/getProcedureRole";
import { getStage } from "../../api/stage";
import { getTerm } from "../../api/stage/terms";
import { Terms } from "../../components/Stages/Terms";
import { useTranslationHook } from "../../hooks";
import { setLoading } from "../../store/UI";
import { ProcedureRole } from "../../types/model/procedure";
import { Procedure } from "../../types/model/procedure/Procedure";
import { Stage, Term } from "../../types/model/stage";

const StageTerms = (props: any) => {
  const { t } = useTranslationHook();
  const dispatch = useDispatch();

  const { accountId, projectId, activityId, procedureId, stageId } =
    useParams<{
      accountId: string;
      projectId: string;
      activityId: string;
      procedureId: string;
      stageId: string;
    }>();

  const [stage, setStage] = useState<Stage>();
  const [term, setTerm] = useState<Term>();
  const [procedure, setProcedure] = useState<Procedure>();
  const [procedureRole, setProcedureRole] = useState<ProcedureRole>();
  const [loadingLocal, setLoadingLocal] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!projectId || !activityId || !procedureId || !stageId) return;

      dispatch(setLoading(true));

      try {
        const [
          stageRes,
          termRes,
          procedureRes,
          procedureRoleRes,
        ] = await Promise.all([
          getStage(Number(projectId), Number(activityId), Number(procedureId), Number(stageId)),
          getTerm(Number(projectId), Number(activityId), Number(procedureId), Number(stageId)),
          getProcedure(Number(projectId), Number(activityId), Number(procedureId)),
          getProcedureRole(Number(projectId), Number(activityId), Number(procedureId)),
        ]);

        setStage(stageRes);
        setTerm(termRes);
        setProcedure(procedureRes);
        setProcedureRole(procedureRoleRes);

        enqueueSnackbar(t("stages.terms.terms-loaded"), {
          variant: "success",
        });
      } catch (error) {
        console.error(error);
        enqueueSnackbar(t("stages.terms.error-loading"), {
          variant: "error",
        });
      } finally {
        dispatch(setLoading(false));
        setLoadingLocal(false);
      }
    };

    fetchData();
  }, [projectId, activityId, procedureId, stageId, dispatch]);

  if (loadingLocal || !stage || !procedure || !procedureRole) return null;

  return (
    <Terms
      stage={stage}
      term={term}
      procedureRole={procedureRole}
      accountId={Number(accountId)}
      projectId={Number(projectId)}
      activityId={Number(activityId)}
      procedureId={Number(procedureId)}
      procedure={procedure}
    />
  );
};

export default StageTerms;